__turbopack_context__.v({
  "tooltip": "InfoTooltip-module-scss-module__IuJW0a__tooltip",
  "trigger": "InfoTooltip-module-scss-module__IuJW0a__trigger",
  "wrapper": "InfoTooltip-module-scss-module__IuJW0a__wrapper",
});
